import {
  ADD_TO_CART,
  DELETE_FROM_CART,
  SELECT_PRODUCT,
  RESET_CART,
  GET_STATUS,
  GET_ORDERS,
  SET_CART,
} from './actions';

const initialState = {
  selectedProduct: {},
  cart: [],
  status: [
    {
      id: 1,
      Status: 'Quote',
    },
  ],
  orders: [],
};

export default function Reducer(state = initialState, action) {
  const { type, data } = action;
  switch (type) {
    case SELECT_PRODUCT:
      return {
        ...state,
        selectedProduct: data,
      };
    case ADD_TO_CART:
      return {
        ...state,
        cart: [...state.cart, data],
      };
    case SET_CART:
      return {
        ...state,
        cart: data,
      };
    case DELETE_FROM_CART:
      return {
        ...state,
        cart: state.cart.filter((item) => item.id !== data),
      };
    case RESET_CART:
      return {
        ...state,
        cart: [],
      };
    case GET_STATUS:
      return {
        ...state,
        status: data,
      };
    case GET_ORDERS:
      return {
        ...state,
        orders: data,
      };
    default:
      return state;
  }
}
